import React from 'react';

import AlexLogo from 'Assets/alex-logo.svg';
import { useTextContext } from 'Contexts/textContext';

/**
 * Mobile headers only have room for one logo: show the customer's uploaded logo, falling back
 * to the ALEX logo when the customer has none.
 */
const MobileHeaderLogo = () => {
  const { retrieveContentfulData } = useTextContext();

  const customerLogo = retrieveContentfulData<string>('logo');
  const displayName = retrieveContentfulData<string>('display_name');

  if (typeof customerLogo !== 'string' || !customerLogo.trim()) {
    return <img src={AlexLogo} alt="Alex" />;
  }

  return <img src={customerLogo} alt={`${displayName || 'Client'} Logo`} data-testid="customer-logo" />;
};

export default MobileHeaderLogo;
